// libs
import React, { memo, useEffect, useMemo, useState } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { RadioGroup } from '@swiggy-private/dls-web-core/dist/components/RadioGroup';
import { Svg16 as InfoIcon } from '@swiggy-private/dls-web-icons/dist/web/generic/info';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// widgets
import SelectCity from './widgets/SelectCity';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignWriteTooltips } from '@/constants/tooltips';
// components
import Tooltip from '@/components/Tooltip';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
// styles
import styles from './Location.module.scss';
var LocationPrefType;
(function (LocationPrefType) {
    LocationPrefType["ALL"] = "all";
    LocationPrefType["SELECTED"] = "selected";
})(LocationPrefType || (LocationPrefType = {}));
function LocationPref({ campaignStatus, cityOptions, cityIds, setCityIds, validationMessages, mode, }) {
    const [citySelectionType, setCitySelectionType] = useState(LocationPrefType.SELECTED);
    useEffect(() => {
        if (cityIds.length === cityOptions.length) {
            setCitySelectionType(LocationPrefType.ALL);
            return;
        }
        setCitySelectionType(LocationPrefType.SELECTED);
    }, [cityIds]);
    const [selectedOptions, setSelectedOptions] = [
        /**
         * filter out the ids that are not present in the cityOptions
         * as in existing campaigns that were created on the old platform
         * might have cities that in which we don't operate anymore
         */
        cityIds
            .map((i) => i.toString())
            .filter((id) => cityOptions.find((option) => option.id === id)),
        setCityIds,
    ];
    const selectAllCity = () => {
        setSelectedOptions(cityOptions.map((option) => option.id));
    };
    const unselectAllCity = () => {
        setSelectedOptions([]);
    };
    const isWriteDisabled = campaignStatus === CampaignStatus.CAMPAIGN_STATUS_LIVE;
    const radioOptions = useMemo(() => [
        {
            label: 'Add all cities',
            value: LocationPrefType.ALL,
            isDisabled: isWriteDisabled,
        },
        {
            label: 'Select cities to add',
            value: LocationPrefType.SELECTED,
            isDisabled: isWriteDisabled,
        },
    ], [campaignStatus]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.header },
            React.createElement("h1", { className: styles.headerTitleContainer },
                React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_High_Emphasis, className: styles.headerTitle }, "Add City preference"),
                React.createElement(Tooltip, { content: CampaignWriteTooltips.CAMPAIGN_CITY_EDIT_WARN },
                    React.createElement(GenericIcon, { Icon: InfoIcon, className: styles.headerTitleInfoIcon, fillColor: DlsColorTokens.text_Low_Emphasis }))),
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Add cities you want your Ad to show up in")),
        React.createElement("div", { className: styles.preftype },
            React.createElement(RadioGroup, { name: "location-pref-type-radio", value: citySelectionType, items: radioOptions, onChange: (e) => {
                    const type = e.target
                        .value;
                    setCitySelectionType(type);
                    if (type === LocationPrefType.ALL) {
                        selectAllCity();
                    }
                    else {
                        unselectAllCity();
                    }
                } })),
        citySelectionType === LocationPrefType.SELECTED && (React.createElement(SelectCity, { disabled: isWriteDisabled, selectedOptions: selectedOptions, setSelectedOptions: setSelectedOptions, cityOptions: cityOptions, errorText: validationMessages.cityIds, mode: mode }))));
}
export default memo(LocationPref);
